/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiIcon, EuiTextColor, useEuiTheme } from '@elastic/eui'

import type { DeploymentSearchResponse } from '@modules/cloud-api/v1/types'

import { getRegionId } from '@/lib/stackDeployments/selectors/fundamentals'

import DeploymentRegion from '../Deployment/DeploymentRegion'

import type { FunctionComponent } from 'react'

type Props = {
  deployment: DeploymentSearchResponse
}

const RegionIndicator: FunctionComponent<Props> = ({ deployment }) => {
  const regionId = getRegionId({ deployment })
  const { euiTheme } = useEuiTheme()

  if (regionId === null) {
    return null
  }

  if (regionId === `ece-region`) {
    return null
  }

  /*
   * We'd normally use `EuiFlex*` components instead of classes, but they render render using <div>
   * `RegionIndicator` is rendered as a child of a <p>, which shouldn't have <div> children
   */
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
      className='regionIndicator-container'
    >
      <span style={{ marginRight: euiTheme.size.s }} className='regionIndicator-icon'>
        <EuiIcon color='text' type='globe' />
      </span>

      <span>
        <EuiTextColor color='subdued'>
          <DeploymentRegion regionId={regionId} />
        </EuiTextColor>
      </span>
    </span>
  )
}

export default RegionIndicator
